<div class="modal-header">
  <h5 class="modal-title">Update Voucher Credits</h5>
  <button type="button" class="btn-close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
  <p class="text-muted mb-3">
    Update <strong>{{ selectionCount }}</strong> selected voucher credit{{ selectionCount !== 1 ? 's' : '' }}.
  </p>

  <div class="mb-3">
    <label class="form-label fw-semibold">Service Code</label>
    <ng-select
      [items]="serviceCodes"
      bindLabel="description"
      bindValue="id"
      [(ngModel)]="serviceCodeId"
      placeholder="Select Service Code"
    >
    </ng-select>
  </div>

  <div class="form-check form-switch mb-3">
    <input
      class="form-check-input"
      type="checkbox"
      id="shouldUpdateExpiredDate"
      [(ngModel)]="shouldUpdateExpiredDate"
    />
    <label class="form-check-label" for="shouldUpdateExpiredDate">Update Expire Date</label>
  </div>

  @if (shouldUpdateExpiredDate) {
    <div class="mb-3">
      <label class="form-label fw-semibold">New Expire Date</label>
      <cert-date-input name="expiredDate" [(model)]="expiredDate" [propertyName]="'expiredDate'" />
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!serviceCodeId && !expiredDate">
    Update
  </button>
</div>
